import $ from 'jquery';
import 'slick-carousel';

import barba from '@barba/core';

barba.hooks.afterEnter(() => {
	const $slider = $('.slider__slick');
	const videoEnd = () => {
		$slider.slick('slickNext');
	};
	const pauseForVideo = (index) => {
		const $slide = $slider.find(`.slick-slide:eq(${index}) .slider__slide`);
		if ($slide.hasClass('slider__slide--video')) {
			const video = $slide.find('video')[0];
			$slider.slick('slickPause');
			video.play();
			video.addEventListener('ended', videoEnd);
		} else {
			$slider.slick('slickPlay');
		}
	};

	$slider.on('beforeChange', (event, slick, currentSlide) => {
		const $slide = $(slick.$slides[currentSlide]).find('.slider__slide');
		if ($slide.hasClass('slider__slide--video')) {
			const video = $slide.find('video')[0];
			video.pause();
			video.removeEventListener('ended', videoEnd);
		}
	});

	$slider.on('afterChange', (event, slick, currentSlide) => {
		pauseForVideo(currentSlide);
	});

	$slider.slick({
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		pauseOnFocus: false,
		fade: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false,
				},
			},
		],
	});

	$slider.on('mouseenter', '.slick-arrow', () => {
		document.querySelector('.cursor--dot').classList.add('active');
	});

	$slider.on('mouseleave', '.slick-arrow', () => {
		document.querySelector('.cursor--dot').classList.remove('active');
	});

	$('.js-scroll-down').on('click', (event) => {
		event.preventDefault();
		window.scrollTo({
			top: $('.slider').outerHeight(),
			left: 0,
			behavior: 'smooth',
		});
	});

	pauseForVideo(0);
});
